import UpdatePowerpointTemplatesModal from "./UpdatePowerpointTemplatesModal";

export default UpdatePowerpointTemplatesModal;
